import Slider from "rc-slider";
import {memo, type FC} from "react";

// TODO: migrate all rc-sliders in the codebase to use this component

const SliderInputField: FC<{
  value: number;
  onChange: (value: number | number[]) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  className?: string;
}> = ({value, onChange, min = 1, max = 100, disabled = false, className = ""}) => {
  return (
    <Slider
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      railStyle={{
        height: 4,
        backgroundColor: "var(--color-neutral-white-dark)",
        zIndex: 1,
      }}
      trackStyle={{
        height: 4,
        backgroundColor: "var(--color-primary-dark-solid)",
        zIndex: 2,
      }}
      handleStyle={[
        {
          height: 24,
          width: 24,
          borderRadius: 200,
          borderWidth: 5,
          borderColor: "var(--color-primary-dark-solid)",
          backgroundColor: "white",
          opacity: 1,
          top: 0,
          zIndex: 2,
        },
      ]}
      dotStyle={{
        height: 8,
        width: 8,
        background: "var(--color-neutral-grey-light)",
        border: "none",
        zIndex: 1,
      }}
      activeDotStyle={{
        background: "var(--color-primary-dark-solid)",
      }}
      marks={{
        [min]: {label: " "},
        [max]: {label: " "},
      }}
      disabled={disabled}
      className={className}
    />
  );
};

export default memo(SliderInputField);
